import React, { useCallback, useEffect, useState } from 'react';
import ReactSpeedometer from 'react-d3-speedometer';

import { useTheme } from '@material-ui/core/styles';

import { Layout } from '../../../components';
import api from '../../../services/api';
import { EndpointsAPI } from '../../../services/Endpoints';
import { secondsToTime } from '../../../utils/secondsToTime';
import TabPanel from '.././../../components/Tab/TabPanel';
import Graficos from './Graficos';
import RelatorioAnalitico from './RelatorioAnalitico';
import RelatorioSintetico from './RelatorioSintetico';
import { TabBase, TabsBase, GaugeWrapper, Box, WrapperTab } from './styles';

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface GaugeProps {
  tempoMinimo: number | any;
  tempoMedio: number | any;
  tempoMaximo: number | any;
}

const Dashboard: React.FC = () => {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const [gaugeMedia, setGaugeMedia] = useState<GaugeProps>();
  const [gaugeComplete, setGaugeComplete] = useState<GaugeProps>();

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const fetchGaugeMedia = useCallback(async () => {
    const { data } = await api.get(EndpointsAPI.odometroPagamentoSucesso);

    setGaugeMedia(data);
  }, []);

  const fetchGaugeComplete = useCallback(async () => {
    const { data } = await api.get(EndpointsAPI.odometroPagamento);

    if (data) {
      setGaugeComplete(data);
    }

    return;
  }, []);

  useEffect(() => {
    fetchGaugeComplete();
    fetchGaugeMedia();
  }, []);

  return (
    <Layout title={'Dashboard de Pagamentos'} titlePage={'Dashboard'}>
      <GaugeWrapper>
        <div>
          <label>Tempo de processamento com sucesso</label>
          <Box style={{ paddingTop: '1rem' }}>
            <div style={{ height: '170px' }}>
              {gaugeMedia?.tempoMaximo !== undefined && (
                <>
                  <div style={{ marginTop: '-1.5rem' }}>
                    <label className={'min'}>
                      {secondsToTime(gaugeMedia?.tempoMinimo).dia >= 1 &&
                      secondsToTime(gaugeMedia?.tempoMinimo).hora === 0
                        ? secondsToTime(gaugeMedia?.tempoMinimo).dia + ' Dia(s)'
                        : secondsToTime(gaugeMedia?.tempoMinimo).hora >= 1 &&
                          secondsToTime(gaugeMedia?.tempoMinimo).dia === 0
                        ? secondsToTime(gaugeMedia?.tempoMinimo).hora +
                          ' Hora(s)'
                        : secondsToTime(gaugeMedia?.tempoMinimo).minuto >= 1 &&
                          secondsToTime(gaugeMedia?.tempoMinimo).hora === 0
                        ? secondsToTime(gaugeMedia?.tempoMinimo).minuto +
                          ' Minuto(s)'
                        : secondsToTime(gaugeMedia?.tempoMinimo).segundo >= 1 &&
                          secondsToTime(gaugeMedia?.tempoMinimo).minuto === 0
                        ? secondsToTime(gaugeMedia?.tempoMinimo).segundo +
                          ' Segundo(s)'
                        : secondsToTime(gaugeMedia?.tempoMinimo).dia +
                          ' segundos(s)'}
                    </label>
                    <label className={'media'}>média</label>
                    <label className={'max'}>
                      {secondsToTime(gaugeMedia?.tempoMaximo).dia >= 1 &&
                      secondsToTime(gaugeMedia?.tempoMaximo).hora === 0
                        ? secondsToTime(gaugeMedia?.tempoMaximo).dia + ' Dia(s)'
                        : secondsToTime(gaugeMedia?.tempoMaximo).hora >= 1 &&
                          secondsToTime(gaugeMedia?.tempoMaximo).dia === 0
                        ? secondsToTime(gaugeMedia?.tempoMaximo).hora +
                          ' Hora(s)'
                        : secondsToTime(gaugeMedia?.tempoMaximo).minuto >= 1 &&
                          secondsToTime(gaugeMedia?.tempoMaximo).hora === 0
                        ? secondsToTime(gaugeMedia?.tempoMaximo).minuto +
                          ' Minuto(s)'
                        : secondsToTime(gaugeMedia?.tempoMaximo).segundo >= 1 &&
                          secondsToTime(gaugeMedia?.tempoMaximo).minuto === 0
                        ? secondsToTime(gaugeMedia?.tempoMaximo).segundo +
                          ' Segundo(s)'
                        : secondsToTime(gaugeMedia?.tempoMaximo).dia +
                          ' Dia(s)'}
                    </label>
                    <ReactSpeedometer
                      minValue={
                        secondsToTime(gaugeMedia?.tempoMinimo).dia >= 1 &&
                        secondsToTime(gaugeMedia?.tempoMinimo).hora === 0
                          ? secondsToTime(gaugeMedia?.tempoMinimo).dia
                          : secondsToTime(gaugeMedia?.tempoMinimo).hora >= 1 &&
                            secondsToTime(gaugeMedia?.tempoMinimo).dia === 0
                          ? secondsToTime(gaugeMedia?.tempoMinimo).hora
                          : secondsToTime(gaugeMedia?.tempoMinimo).minuto >=
                              1 &&
                            secondsToTime(gaugeMedia?.tempoMinimo).hora === 0
                          ? secondsToTime(gaugeMedia?.tempoMinimo).minuto
                          : secondsToTime(gaugeMedia?.tempoMinimo).segundo >=
                              1 &&
                            secondsToTime(gaugeMedia?.tempoMinimo).minuto === 0
                          ? secondsToTime(gaugeMedia?.tempoMinimo).segundo
                          : secondsToTime(gaugeMedia?.tempoMinimo).dia
                      }
                      maxValue={
                        secondsToTime(gaugeMedia?.tempoMaximo).dia >= 1 &&
                        secondsToTime(gaugeMedia?.tempoMaximo).hora === 0
                          ? secondsToTime(gaugeMedia?.tempoMaximo).dia
                          : secondsToTime(gaugeMedia?.tempoMaximo).hora >= 1 &&
                            secondsToTime(gaugeMedia?.tempoMaximo).dia === 0
                          ? secondsToTime(gaugeMedia?.tempoMaximo).hora
                          : secondsToTime(gaugeMedia?.tempoMaximo).minuto >=
                              1 &&
                            secondsToTime(gaugeMedia?.tempoMaximo).hora === 0
                          ? secondsToTime(gaugeMedia?.tempoMaximo).minuto
                          : secondsToTime(gaugeMedia?.tempoMaximo).segundo >=
                              1 &&
                            secondsToTime(gaugeMedia?.tempoMaximo).minuto === 0
                          ? secondsToTime(gaugeMedia?.tempoMaximo).segundo
                          : secondsToTime(gaugeMedia?.tempoMaximo).dia
                      }
                      value={
                        secondsToTime(gaugeMedia?.tempoMedio).dia >= 1 &&
                        secondsToTime(gaugeMedia?.tempoMedio).hora === 0
                          ? secondsToTime(gaugeMedia?.tempoMedio).dia
                          : secondsToTime(gaugeMedia?.tempoMedio).hora >= 1 &&
                            secondsToTime(gaugeMedia?.tempoMedio).dia === 0
                          ? secondsToTime(gaugeMedia?.tempoMedio).hora
                          : secondsToTime(gaugeMedia?.tempoMedio).minuto >= 1 &&
                            secondsToTime(gaugeMedia?.tempoMedio).hora === 0
                          ? secondsToTime(gaugeMedia?.tempoMedio).minuto
                          : secondsToTime(gaugeMedia?.tempoMedio).segundo >=
                              1 &&
                            secondsToTime(gaugeMedia?.tempoMedio).minuto === 0
                          ? secondsToTime(gaugeMedia?.tempoMedio).segundo
                          : secondsToTime(gaugeMedia?.tempoMedio).dia
                      }
                      needleHeightRatio={0.4}
                      ringWidth={56}
                      needleColor="#D9D9D9"
                      segments={3}
                      segmentColors={['#166649', '#AB934B', '#910F2D']}
                      maxSegmentLabels={0}
                      currentValueText={`#{value} seg`}
                      currentValuePlaceholderStyle={`#{value}`}
                    />
                  </div>
                </>
              )}
            </div>
          </Box>
        </div>
        <div>
          <label>Tempo de homologação completo</label>
          <Box style={{ paddingTop: '1rem' }}>
            <div style={{ height: '170px' }}>
              {gaugeComplete?.tempoMaximo !== undefined && (
                <>
                  <div style={{ marginTop: '-1.5rem' }}>
                    <label className={'min'}>
                      {secondsToTime(gaugeComplete?.tempoMinimo).dia >= 1 &&
                      secondsToTime(gaugeComplete?.tempoMinimo).hora === 0
                        ? secondsToTime(gaugeComplete?.tempoMinimo).dia +
                          ' Dia(s)'
                        : secondsToTime(gaugeComplete?.tempoMinimo).hora >= 1 &&
                          secondsToTime(gaugeComplete?.tempoMinimo).dia === 0
                        ? secondsToTime(gaugeComplete?.tempoMinimo).hora +
                          ' Hora(s)'
                        : secondsToTime(gaugeComplete?.tempoMinimo).minuto >=
                            1 &&
                          secondsToTime(gaugeComplete?.tempoMinimo).hora === 0
                        ? secondsToTime(gaugeComplete?.tempoMinimo).minuto +
                          ' Minuto(s)'
                        : secondsToTime(gaugeComplete?.tempoMinimo).segundo >=
                            1 &&
                          secondsToTime(gaugeComplete?.tempoMinimo).minuto === 0
                        ? secondsToTime(gaugeComplete?.tempoMinimo).segundo +
                          ' Segundo(s)'
                        : secondsToTime(gaugeComplete?.tempoMinimo).dia +
                          ' Dia(s)'}
                    </label>
                    <label className={'media'}>média</label>
                    <label className={'max'}>
                      {secondsToTime(gaugeComplete?.tempoMaximo).dia >= 1 &&
                      secondsToTime(gaugeComplete?.tempoMaximo).hora === 0
                        ? secondsToTime(gaugeComplete?.tempoMaximo).dia +
                          ' Dia(s)'
                        : secondsToTime(gaugeComplete?.tempoMaximo).hora >= 1 &&
                          secondsToTime(gaugeComplete?.tempoMaximo).dia === 0
                        ? secondsToTime(gaugeComplete?.tempoMaximo).hora +
                          ' Hora(s)'
                        : secondsToTime(gaugeComplete?.tempoMaximo).minuto >=
                            1 &&
                          secondsToTime(gaugeComplete?.tempoMaximo).hora === 0
                        ? secondsToTime(gaugeComplete?.tempoMaximo).minuto +
                          ' Minuto(s)'
                        : secondsToTime(gaugeComplete?.tempoMaximo).segundo >=
                            1 &&
                          secondsToTime(gaugeComplete?.tempoMaximo).minuto === 0
                        ? secondsToTime(gaugeComplete?.tempoMaximo).segundo +
                          ' Segundo(s)'
                        : secondsToTime(gaugeComplete?.tempoMaximo).dia +
                          ' Dia(s)'}
                    </label>
                    <ReactSpeedometer
                      minValue={gaugeComplete?.tempoMinimo}
                      maxValue={gaugeComplete?.tempoMaximo}
                      value={gaugeComplete?.tempoMedio}
                      needleHeightRatio={0.4}
                      ringWidth={56}
                      needleColor="#D9D9D9"
                      segments={3}
                      segmentColors={['#166649', '#AB934B', '#910F2D']}
                      maxSegmentLabels={0}
                      currentValueText={
                        secondsToTime(gaugeComplete?.tempoMedio).dia >= 1 &&
                        secondsToTime(gaugeComplete?.tempoMedio).hora === 0
                          ? secondsToTime(gaugeComplete?.tempoMedio).dia +
                            ' Dia(s)'
                          : secondsToTime(gaugeComplete?.tempoMedio).hora >=
                              1 &&
                            secondsToTime(gaugeComplete?.tempoMedio).dia === 0
                          ? secondsToTime(gaugeComplete?.tempoMedio).hora +
                            ' Hora(s)'
                          : secondsToTime(gaugeComplete?.tempoMedio).minuto >=
                              1 &&
                            secondsToTime(gaugeComplete?.tempoMedio).hora === 0
                          ? secondsToTime(gaugeComplete?.tempoMedio).minuto +
                            ' Minuto(s)'
                          : secondsToTime(gaugeComplete?.tempoMedio).segundo >=
                              1 &&
                            secondsToTime(gaugeComplete?.tempoMedio).minuto ===
                              0
                          ? secondsToTime(gaugeComplete?.tempoMedio).segundo +
                            ' Segundo(s)'
                          : secondsToTime(gaugeComplete?.tempoMedio).dia +
                            ' Dia(s)'
                      }
                    />
                  </div>
                </>
              )}
            </div>
          </Box>
        </div>
      </GaugeWrapper>

      <TabsBase value={value} onChange={handleChange} aria-label="DASHBOARD">
        <TabBase label="RELATÓRIO GERAL" {...a11yProps(0)} />
        <TabBase label="RELATÓRIO ANALÍTICO" {...a11yProps(1)} />
        <TabBase label="GRÁFICOS" {...a11yProps(2)} />
      </TabsBase>

      <WrapperTab>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <RelatorioSintetico />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <RelatorioAnalitico />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Graficos />
        </TabPanel>
      </WrapperTab>
    </Layout>
  );
};

export default Dashboard;
